import { Alert, ButtonBorder, Div, HeaderBack, Label } from "components";
import { Ecolors } from "constants/themes";
import React, { useRef, useState } from "react";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useDispatch } from "react-redux";
import { draftQuestion } from "reducer/authen";
import { apiMain } from "services/apiMain";
import { goBack, useNavigationLog } from "services/navigation";
import { useAppSelector } from "store/hooks";
import ProcessHeader from "./ProcessHeader";
// import StepComQuestion from "./StepComQuestion";
import { FlatList, ScrollView } from "react-native";
import ComQuestion from "./ComQuestion";
import { heightScreen, Log, widthScreen } from "utils";

type OptionType = {
  name: string;
  score: number;
};

type Answer = {
  id: number;
  questionNo: number;
  options: string[];
};

function EditRiskQuestionModal() {
  const questions = useAppSelector<any[]>(
    (state) => state.authen.question.questions,
  );
  const [listAnswer, setListAnswer] = useState<Answer[]>([]);
  const [indexFocus, setIndexFocus] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);

  const flatlistRef = useRef(null);
  const insets = useSafeAreaInsets();
  const dispatch = useDispatch();
  const navigate = useNavigationLog();

  const onSelect = (option: OptionType) => {
    const currentQuestion = questions[indexFocus]; // câu hỏi hiện tại

    setListAnswer((prev) => {
      const copy = [...prev];
      const current = copy[indexFocus] || {
        id: currentQuestion.id,
        questionNo: currentQuestion.questionNo,
        options: [] as string[],
      };
      const exists = current.options.includes(option.name);

      if (currentQuestion.isOneChoice) {
        // Nếu là 1 lựa chọn và đã chọn rồi thì không cho bỏ
        if (exists) return prev;
        current.options = [option.name];
      } else {
        const exists = current.options.includes(option.name);
        current.options = exists
          ? current.options.filter((n) => n !== option.name)
          : [...current.options, option.name];
      }

      copy[indexFocus] = current;
      return copy;
    });
  };

  const renderItem = ({ item }) => {
    return (
      <Div
        style={{
          width: widthScreen,
          height: heightScreen * 0.75,
        }}
      >
        <ScrollView
          nestedScrollEnabled
          showsVerticalScrollIndicator={false}
          scrollEnabled
          horizontal={false}
          style={{
            paddingHorizontal: 20,
            paddingTop: 20,
            paddingBottom: heightScreen * 0.1,
            flex: 1,
          }}
        >
          <Label multilanguage={false}>{item.content}</Label>
          {item?.options?.map((option: any, index: number) => {
            const isSelected = listAnswer[indexFocus]?.options?.includes(
              option?.name,
            );
            return (
              <Div paddingTop={13} key={index}>
                <ComQuestion
                  data={option}
                  onPress={(t) => {
                    Log("option>>", option);
                    onSelect(option);
                  }}
                  isSelect={isSelected}
                  type={2}
                />
              </Div>
            );
          })}
        </ScrollView>
      </Div>
    );
  };

  const onPrevious = () => {
    if (indexFocus == 0) {
      goBack();
      return;
    }
    scrollTo(indexFocus - 1);

    setTimeout(() => {
      setIndexFocus(indexFocus - 1);
    }, 200);
  };

  const onNext = () => {
    if (listAnswer?.length <= indexFocus) {
      return;
    }
    if (indexFocus == questions?.length - 1) {
      submitForm();
      return;
    }

    scrollTo(indexFocus + 1);
    setIndexFocus(indexFocus + 1);
  };

  const submitForm = async () => {
    try {
      setLoading(true);
      const obj = {
        appetiteId: null,
        questionResults: listAnswer,
        isSave: false,
      };
      const t: any = await apiMain.submitQuestion(obj);
      if (t.status == 200) {
        dispatch(draftQuestion(obj));
        navigate("ResultModal", {
          flow: "Submit",
          data: t.data,
        });
        return;
      }
      Alert.showError({
        content: t?.message,
        type: 2,
        multilanguage: false,
        title: `alert.thatbai`,
        onConfirm: () => {
          navigate("ResultModal");
        },
      });
      return;
    } catch (error: any) {
      Alert.showError({
        content: error.message,
        type: 2,
        multilanguage: false,
        title: `alert.thatbai`,
        onConfirm: () => {
          navigate("ResultModal");
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const scrollTo = async (index: number) => {
    if (!flatlistRef.current) {
      return;
    }

    const offset = index * widthScreen;
    flatlistRef.current?.scrollToOffset({
      offset,
      animated: true,
    });
  };

  return (
    <Div screen={true} backgroundColor={Ecolors.whiteColor}>
      <HeaderBack
        type={2}
        title={`riskquestionscreen.bangkhaosatkhauviruiro`}
      />
      <ProcessHeader index={indexFocus} max={questions?.length} />

      <FlatList
        ref={flatlistRef}
        data={questions}
        renderItem={renderItem}
        horizontal={true}
        scrollEnabled={false}
        pagingEnabled={true}
        showsHorizontalScrollIndicator={false}
        keyExtractor={(item, index) => item.id?.toString() || index.toString()}
        extraData={questions}
      />

      <Div
        flexDirection={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        style={{
          position: "absolute",
          bottom: insets.bottom + 20,
          left: 20,
          right: 20,
          paddingTop: 6,
        }}
      >
        <ButtonBorder
          onPress={() => {
            onPrevious();
          }}
          width={148}
          height={48}
          title={`riskquestionscreen.trove`}
          type={2}
        />
        <ButtonBorder
          isDisable={
            listAnswer?.[indexFocus]?.options.length > 0 ? false : true
          }
          onPress={() => {
            onNext();
          }}
          loading={loading}
          width={148}
          height={48}
          title={`riskquestionscreen.ketiep`}
          type={1}
        />
      </Div>
    </Div>
  );
}

export default React.memo(EditRiskQuestionModal);
